import axios from 'axios';

import { exportConfigConstants } from '../constants';

export const exportConfigActions = {
    fetchExportConfigs,
    createExportConfig,
    updateExportConfig,
    deleteExportConfig,
};

function fetchExportConfigs() {
    return async (dispatch) => {
        dispatch(request());

        try {
            const response = await axios.get('/export-configs');

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to get export configs at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: exportConfigConstants.FETCH_CONFIGS_REQUEST };
    }
    function success(exportConfigs) {
        return {
            type: exportConfigConstants.FETCH_CONFIGS_SUCCESS,
            exportConfigs,
        };
    }
    function failure(error) {
        return { type: exportConfigConstants.FETCH_CONFIGS_FAILURE, error };
    }
}

function createExportConfig(template) {
    return async (dispatch) => {
        dispatch(request());

        try {
            const response = await axios.post('/export-configs', {
                template: template,
            });

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to create export config at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: exportConfigConstants.CREATE_CONFIG_REQUEST };
    }
    function success(exportConfigs) {
        return {
            type: exportConfigConstants.CREATE_CONFIG_SUCCESS,
            exportConfigs,
        };
    }
    function failure(error) {
        return { type: exportConfigConstants.CREATE_CONFIG_FAILURE, error };
    }
}

function updateExportConfig(template) {
    return async (dispatch) => {
        dispatch(request());

        try {
            const url = '/export-configs/' + template.export_config_id;
            const response = await axios.put(url, {
                template: template,
            });

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update export config at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: exportConfigConstants.UPDATE_CONFIG_REQUEST };
    }
    function success(exportConfigs) {
        return {
            type: exportConfigConstants.UPDATE_CONFIG_SUCCESS,
            exportConfigs,
        };
    }
    function failure(error) {
        return { type: exportConfigConstants.UPDATE_CONFIG_FAILURE, error };
    }
}

function deleteExportConfig(id) {
    return async (dispatch) => {
        dispatch(request());

        try {
            const url = '/export-configs/' + id;
            const response = await axios.delete(url);

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to delete export config at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: exportConfigConstants.DELETE_CONFIG_REQUEST };
    }
    function success(exportConfigs) {
        return {
            type: exportConfigConstants.DELETE_CONFIG_SUCCESS,
            exportConfigs,
        };
    }
    function failure(error) {
        return { type: exportConfigConstants.DELETE_CONFIG_FAILURE, error };
    }
}
